import { render, staticRenderFns } from "./CanvasChart.vue?vue&type=template&id=c45bd30c&scoped=true"
import script from "./CanvasChart.vue?vue&type=script&lang=js"
export * from "./CanvasChart.vue?vue&type=script&lang=js"
import style0 from "./CanvasChart.vue?vue&type=style&index=0&id=c45bd30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45bd30c",
  null
  
)

export default component.exports